import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import VersionHistory from '../../../../utils/VersionHistory';
import GetIcon from '../../../../utils/Icon';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({po,grnData,activityboll}) => {
  const [showActivity, setShowActivity] = useState(true);
  return (
    <div className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px", height: '72vh', overflowY: 'scroll',flexWrap:'nowrap' }} >
      <div className="col-12 mt-1">
         <div className="row mb-2">

      <div className="col-md-6">
        <Input
        
        id="orderNo" label="No." readOnly value={po?.current_op} style={{ height: '30px' }} />
      </div>
      <div className="col-md-6">
        <Input id="orderdatepo" type="text" readOnly style={{ height: '30px',backgroundColor:'#f8f6f6' }} label="Date" value={po.currentdate}  />
      </div>
         </div>
      </div>
     

     <div className="col-12 mb-3">

       {/* <div className="col-12 mb-3"> */}
               <SelectSearch
                  list={po.grnlist}
                  label="Select GRN No."
                  getOptionLabel={(item) => item.name}
                  getOptionValue={(item) => item.name}
                  value={po.selectedgrn}
                  onChange={(val) => po.setselectedgrn(val)}
                /> 
              
      
            {/* </div> */}




         {/* <div className="row mb-2">
             <div className="col-6">
         <Input id="po" label="PO No." readOnly value={po?.po}   style={{ height: '30px' }} />
      </div>
      <div className="col-6">
         <Input id="grnno" label="GRN No." readOnly value={grnData.against_purchase_receipt} style={{ height: '30px' }} />
      </div>

            </div> */}
         </div>


     <div className="col-12 mb-2">
         <Input id="po" label="PO No." readOnly value={po?.po}   style={{ height: '30px' }} />

    </div>
     
      <div className="col-12 mb-2" >
         <Input id="vandortitle" label="Supplier" readOnly value={po.supplier}   style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-2" >
         <Input id="vandortitle" label="Source Bin" readOnly value={grnData.items?.[0]?.s_warehouse}   style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-2" >
       
         <Input id="vandortitle" label="Post Date" readOnly value={grnData.posting_date}   style={{ height: '30px' }} />

      </div>
      <div className="col-12 ">
         <Input id="vandortitle" label="Post Time" readOnly value={grnData?.posting_time?.split('.')[0]}   style={{ height: '30px' }} />
      </div>
      
     
      <div className='col-12'>
                  <div>
                     <div className="col-12">
                        <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                           <p className="firstcolor m-0" >
                              Activity
                           </p>
                           <GetIcon
                              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
                              size={22}
                           />
                        </div>
                        {showActivity && (
                           <VersionHistory doctype="Stock Entry" docname={po?.current_op} activityboll={activityboll} />
      
                        )}
                     </div>
                  </div>
               </div>

    </div>
  )
}

export default Tab1